module.exports = __webpack_public_path__ + "media/assets/community/breadcrumbs-faria-dde671f55833f0cacc85eb70357d819e7f7848268eac23ee86ccebe289d690fe.png";